export function initCompareAdded() {
    const template = document.getElementById('confirm-bubble-template'); // optional
    const navTemplate = document.getElementById('confirm-bubble-menu-template'); // required
    const navQuoteTemplate = document.getElementById('confirm-bubble-menu-quote-template'); // required for buyBtn
    const bubbleAnchor = document.getElementById('product-compare-bag'); // required
    const myQuotesAnchor = document.getElementById('product_bag_link'); // required for buyBtn

    const BUTTON_SELECTOR = '.product-list__item-compare-button';
    const ACTIVE_CLASS = 'product-list__item-compare-button--active';
    const EXTRA_ACTIVE_CLASS = 'product-compare-bag';
    const COMPARE_ACTIVE_CLASS = 'product__compare-button--active';
    const HIDDEN_CLASS = 'hidden';
    const SHOW_DURATION = 1200;
    const GAP = 6;

    function showExtraBubble(message, anchor, templateElement) {
        if (!templateElement || !anchor) return;

        const extraBubble = templateElement.cloneNode(true);
        extraBubble.removeAttribute('id');
        extraBubble.classList.remove(HIDDEN_CLASS, 'show', 'position-below');
        extraBubble.textContent = message;

        document.body.appendChild(extraBubble);

        const anchorRect = anchor.getBoundingClientRect();
        const scrollY = window.scrollY || window.pageYOffset;
        const scrollX = window.scrollX || window.pageXOffset;
        const extraW = extraBubble.getBoundingClientRect().width;

        extraBubble.style.position = 'absolute';
        extraBubble.style.top = anchorRect.bottom + scrollY + GAP + 'px';
        extraBubble.style.left = anchorRect.left + scrollX + (anchorRect.width / 2 - extraW / 2) + 'px';

        requestAnimationFrame(() => extraBubble.classList.add('show'));
        setTimeout(() => {
            extraBubble.classList.remove('show');
            setTimeout(() => extraBubble.remove(), 160);
        }, SHOW_DURATION);
    }

    function showQuoteBubble(message, anchor, templateElement) {
        if (!templateElement || !anchor) return;

        const extraBubble = templateElement.cloneNode(true);
        extraBubble.removeAttribute('id');
        extraBubble.classList.remove(HIDDEN_CLASS, 'show', 'position-below');
        extraBubble.textContent = message;

        document.body.appendChild(extraBubble);

        const anchorRect = anchor.getBoundingClientRect();
        const scrollY = window.scrollY || window.pageYOffset;
        const scrollX = window.scrollX || window.pageXOffset;
        const extraW = extraBubble.getBoundingClientRect().width;

        extraBubble.style.position = 'absolute';
        extraBubble.style.top = anchorRect.bottom + scrollY + GAP + 'px';
        extraBubble.style.left = anchorRect.left + scrollX + (anchorRect.width / 2 - extraW / 2) + 'px';

        requestAnimationFrame(() => extraBubble.classList.add('show'));
        setTimeout(() => {
            extraBubble.classList.remove('show');
            setTimeout(() => extraBubble.remove(), 160);
        }, SHOW_DURATION);
    }

    document.body.addEventListener('click', (e) => {
        const btn = e.target.closest(BUTTON_SELECTOR);
        const compareBtn = e.target.closest('#compareBtn');
        const buyBtn = e.target.closest('#buyBtn');

        // --- Listknappar ---
        if (btn && template) {
            const currentlyActive = btn.classList.contains(ACTIVE_CLASS);
            const newIsActive = !currentlyActive;

            if (newIsActive) {
                btn.classList.add(ACTIVE_CLASS, EXTRA_ACTIVE_CLASS);
            } else {
                btn.classList.remove(ACTIVE_CLASS, EXTRA_ACTIVE_CLASS);
            }

            const addText = template.dataset.addText;
            const removeText = template.dataset.removeText;
            const message = newIsActive ? addText : removeText;

            // VANLIG BUBBLA
            const bubble = template.cloneNode(true);
            bubble.removeAttribute('id');
            bubble.classList.remove(HIDDEN_CLASS, 'show', 'position-below');
            bubble.textContent = message;
            document.body.appendChild(bubble);

            const rect = btn.getBoundingClientRect();
            const OFFSET_X = 16;
            let centerX = rect.left + rect.width / 2 + window.scrollX + OFFSET_X;
            bubble.style.top = rect.bottom + window.scrollY + 'px';

            const bRect = bubble.getBoundingClientRect();
            const bW = bRect.width;
            const bH = bRect.height;
            const spaceAbove = rect.top;
            const spaceBelow = window.innerHeight - rect.bottom;

            if (spaceAbove < bH + GAP && spaceBelow > bH + GAP) {
                bubble.classList.add('position-below');
                bubble.style.top = rect.bottom + window.scrollY + 'px';
            } else {
                bubble.classList.remove('position-below');
                bubble.style.top = rect.top + window.scrollY + 'px';
            }

            const pad = 8;
            const pageX = window.scrollX;
            const minCenter = pageX + pad + bW / 2;
            const maxCenter = window.scrollX + document.documentElement.clientWidth - pad - bW / 2;
            centerX = Math.min(Math.max(centerX, minCenter), maxCenter);
            bubble.style.left = centerX + 'px';

            requestAnimationFrame(() => bubble.classList.add('show'));
            setTimeout(() => {
                bubble.classList.remove('show');
                setTimeout(() => bubble.remove(), 160);
            }, SHOW_DURATION);
            
            showExtraBubble(message, bubbleAnchor, navTemplate);
        }

        // --- compareBtn ---
        if (compareBtn) {
            const isActive = compareBtn.classList.contains(COMPARE_ACTIVE_CLASS);
            const newIsActive = !isActive;

            if (newIsActive) {
                compareBtn.classList.add(COMPARE_ACTIVE_CLASS);
            } else {
                compareBtn.classList.remove(COMPARE_ACTIVE_CLASS);
            }

            const addText = navTemplate.dataset.addText || "Added";
            const removeText = navTemplate.dataset.removeText || "Removed";
            const message = newIsActive ? addText : removeText;

            showExtraBubble(message, bubbleAnchor, navTemplate);
        }

        // --- buyBtn ---
        if (buyBtn) {
            const message = navQuoteTemplate.dataset.addText || "Added";

            // Extra bubble under #product_bag_link using navQuoteTemplate
            showQuoteBubble(message, myQuotesAnchor, navQuoteTemplate);
        }
    }, { passive: true });
}